// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Xml5","newExpiryDate":"styles_newExpiryDate__L0J1e","footer":"styles_footer__1XrxH"};